import * as yup from 'yup';

const AddReferralSchema = yup.object({
  name: yup.string().required('Name is required'),
  referralSource: yup.string().required('Referral Source is required'),
});

export { AddReferralSchema };
